module.exports = __webpack_public_path__ + "img/tarot-shuffle.80bf7ef2.png";